import { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useFieldArray, useFormContext } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import "../../QuotationForm/components/Schedule/Schedule.scss";
import { ICountries } from "pages/shipper/RequestForm/components/Schedule/Types";
import FlightComponent from "pages/provider/QuotationForm/components/Schedule/Delivery/FlightComponent";

const customFlightInfo = {
  airline_code: "",
  flight_number: null,
  departure_date: null,
  departure_time: null,
  departure_airport_code: "",
  arrival_date: null,
  arrival_time: null,
  arrival_airport_code: "",
};
interface AirFreightProps {
  countries: ICountries[];
}
function EditFlight(props: AirFreightProps) {
  const { countries } = props;
  const methods = useFormContext();
  const { fields, append, remove } = useFieldArray({
    name: "schedule.flights",
    control: methods.control,
    shouldUnregister: true,
  });
  useEffect(() => {
    if (fields?.length === 0) append(customFlightInfo);
  }, []);
  return (
    <>
      <hr className="mt-xl mb-xl" />
      <div className="mt-4">
        <Row className="mb-1">
          <Col xs={12}>
            <div className="flex-row flex-wrap">
              <div className="w-200 pr-16">
                <h6>
                  <FormattedMessage id="tracking.components.editScheduleDialog.editFlight" defaultMessage="Edit flight" />
                </h6>
              </div>
              <div style={{ width: "504px" }}>
                {fields.map((airplane, index) => (
                  <div key={airplane.id}>
                    <FlightComponent index={index} countries={countries} remove={remove} />
                  </div>
                ))}
                <div className="flex-row mid-wrapper mt-4">
                  <div className="w-192 align-date">
                    <p onClick={() => append(customFlightInfo)} className="text-blue-200 font-b4 cursor-pointer">
                      <FormattedMessage id="quote.provider.schedule.addFlight" defaultMessage="Add flight" />
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}
export default EditFlight;
